import React from 'react'
import styled from 'styled-components'
import { Skeleton } from '../Skeleton'

const Wrapper = styled.div`
  width: 100%;
  overflow-x: auto;
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.radii.lg};
  background: ${({ theme }) => theme.colors.surface};
  box-shadow: ${({ theme }) => theme.shadow.sm};
`

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
`

const Th = styled.th`
  text-align: left;
  font-weight: 600;
  font-size: ${({ theme }) => theme.fontSizes.sm};
  color: ${({ theme }) => theme.colors.muted};
  padding: 12px 14px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};
  background: ${({ theme }) => theme.colors.surface};
  position: sticky;
  top: 0;
  z-index: 1;
  width: ${({ width }) => width || 'auto'};
`

const Td = styled.td`
  padding: 14px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};
  font-size: ${({ theme }) => theme.fontSizes.md};
  color: ${({ theme }) => theme.colors.text};
`

const Tr = styled.tr`
  &:hover {
    background: rgba(0,0,0,0.02);
  }
`

export function Table({ columns = [], data = [], loading = false, skeletonRowCount = 8, emptyMessage = 'Nessun dato disponibile.', skeletonHeight = '1.2em', rowStyle, renderRow }) {
  if (!loading && data.length === 0) {
    return (
      <Wrapper>
        <StyledTable>
          <thead>
            <tr>
              {columns.map((col) => (
                <Th key={col.key || col.accessor || col.header || col.label} width={col.width}>{col.header || col.label}</Th>
              ))}
            </tr>
          </thead>
          <tbody>
            <tr>
              <Td colSpan={columns.length} style={{ textAlign: 'center', color: '#64748b', padding: '32px' }}>
                {emptyMessage}
              </Td>
            </tr>
          </tbody>
        </StyledTable>
      </Wrapper>
    )
  }

  return (
    <Wrapper>
      <StyledTable>
        <thead>
          <tr>
            {columns.map((col) => (
              <Th key={col.key || col.accessor || col.header || col.label} width={col.width}>{col.header || col.label}</Th>
            ))}
          </tr>
        </thead>
        <tbody>
          {loading
            ? Array.from({ length: skeletonRowCount }).map((_, rIdx) => (
                <Tr key={'sk-' + rIdx}>
                  {columns.map((col, cIdx) => (
                <Td key={'sk-' + rIdx + '-' + (col.key || col.accessor || cIdx)}>
                  <Skeleton height={skeletonHeight} />
                </Td>
              ))}
                </Tr>
              ))
            : data.map((row, i) => {
                const resolvedRowStyle = typeof rowStyle === 'function' ? rowStyle(row, i) : rowStyle
                // Custom row renderer — return <tr> with custom <td> layout (e.g. colSpan)
                if (renderRow) {
                  const custom = renderRow(row, i, columns)
                  if (custom) return custom
                }
                return (
                <Tr key={row.id ?? i} style={resolvedRowStyle}>
                  {columns.map((col) => {
                    const cellKey = (col.key || col.accessor || col.header || col.label) + '-' + (row.id ?? i)
                    if (col.render) {
                      return <Td key={cellKey}>{col.render(row)}</Td>
                    }
                    if (typeof col.accessor === 'function') {
                      return <Td key={cellKey}>{col.accessor(row)}</Td>
                    }
                    return <Td key={cellKey}>{row[col.accessor]}</Td>
                  })}
                </Tr>
                )
              })}
        </tbody>
      </StyledTable>
    </Wrapper>
  )
}
